import ServiceCRUD from '../../../../../services/ServiceCRUDFLEXUC';

export class Service extends ServiceCRUD {
  constructor() {
    super('/api/filas');
  }
}

export default new Service();
